import { z } from "zod";

/** UI form state: blank dates deliberately mean no declared coverage. */
export const evidenceCoverageFormSchema = z.object({
  coversFrom: z.union([z.literal(""), z.iso.date()]),
  coversTo: z.union([z.literal(""), z.iso.date()]),
}).superRefine(({ coversFrom, coversTo }, ctx) => {
  if (coversFrom && coversTo && coversFrom > coversTo) {
    ctx.addIssue({ code: "custom", path: ["coversTo"], message: "Coverage end must be on or after coverage start." });
  }
});

export type EvidenceCoverageForm = z.infer<typeof evidenceCoverageFormSchema>;

export function coverageError(value: EvidenceCoverageForm): string | undefined {
  const parsed = evidenceCoverageFormSchema.safeParse(value);
  return parsed.success ? undefined : parsed.error.issues[0]?.message;
}
